import React from 'react';
import { Box } from '@mui/material';

const AnimatedBackground = () => (
  <Box
    sx={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: -1,
      background: "radial-gradient(circle at 50% 50%, #0A1929 0%, #000000 100%)",
      overflow: "hidden",
      "&::before": {
        content: '""',
        position: "absolute",
        width: "200%",
        height: "200%",
        background:
          "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Cdefs%3E%3CradialGradient id='a' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23042644'/%3E%3Cstop offset='1' stop-color='%23000000'/%3E%3C/radialGradient%3E%3ClinearGradient id='b' gradientUnits='userSpaceOnUse' x1='0' y1='750' x2='1550' y2='750'%3E%3Cstop offset='0' stop-color='%23021322'/%3E%3Cstop offset='1' stop-color='%23000000'/%3E%3C/linearGradient%3E%3C/defs%3E%3Crect fill='url(%23a)' width='2000' height='1500'/%3E%3Crect fill='url(%23b)' width='2000' height='1500'/%3E%3C/svg%3E\")",
        backgroundAttachment: "fixed",
        backgroundSize: "cover",
        opacity: 0.4,
        animation: "gradient 15s ease infinite",
        transform: "rotate(10deg)",
      },
      "&::after": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "radial-gradient(circle at 25% 25%, rgba(25, 118, 210, 0.1) 0%, transparent 50%)",
        animation: "pulse 15s ease-in-out infinite alternate",
      },
      "@keyframes gradient": {
        "0%": {
          transform: "rotate(10deg) scale(1)",
        },
        "50%": {
          transform: "rotate(10deg) scale(1.2)",
        },
        "100%": {
          transform: "rotate(10deg) scale(1)",
        },
      },
      "@keyframes pulse": {
        "0%": {
          opacity: 0.3,
        },
        "50%": {
          opacity: 0.6,
        },
        "100%": {
          opacity: 0.3,
        },
      },
    }}
  />
);

export default AnimatedBackground; 